import { Link } from "react-router-dom";
import { Monogram } from "@/components/Navbar";
import { NAV_LINKS, OFFICE_EMAIL, OFFICE_LOCATION, OFFICE_PHONE, OFFICE_PHONE_TEL, SITE_URL, GLOBAL_DISCLAIMER, PRACTICE_AREAS } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-gold/15 bg-ink">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-10">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-3">
              <Monogram />
              <span className="leading-none">
                <span className="block font-serif text-lg tracking-[0.08em] text-ivory">SMART</span>
                <span className="mt-1 block font-mono text-[8.5px] uppercase tracking-[0.42em] text-gold/90">Legal Solutions</span>
              </span>
            </div>
            <p className="mt-6 font-serif text-lg italic text-ivory/60">Clarity Before Action. Strategy Before Litigation.</p>
            <p className="mt-4 text-xs leading-relaxed text-slate">{GLOBAL_DISCLAIMER}</p>
          </div>
          <div>
            <p className="mono-label mb-6">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`} to={l.to} className="text-sm text-ivory/60 transition-colors duration-300 hover:text-gold">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mono-label mb-6">Areas of Practice</p>
            <ul className="space-y-3">
              {PRACTICE_AREAS.slice(0, 6).map((a) => (
                <li key={a.n}>
                  <Link to="/practice-areas" className="text-sm text-ivory/60 transition-colors duration-300 hover:text-gold">
                    {a.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="mono-label mb-6">Office</p>
            <address className="space-y-3 text-sm not-italic text-ivory/60">
              <p>Smart Legal Solutions</p>
              <p>{OFFICE_LOCATION}</p>
              <p>
                <a data-testid="footer-email-link" href={`mailto:${OFFICE_EMAIL}`} className="transition-colors duration-300 hover:text-gold">
                  {OFFICE_EMAIL}
                </a>
              </p>
              <p>
                <a data-testid="footer-phone-link" href={`tel:${OFFICE_PHONE_TEL}`} className="transition-colors duration-300 hover:text-gold">
                  {OFFICE_PHONE}
                </a>
              </p>
              <p className="font-mono text-[11px] tracking-[0.1em] text-slate">{SITE_URL.replace("https://", "")}</p>
            </address>
            <p className="mt-6 font-mono text-[10px] uppercase leading-relaxed tracking-[0.15em] text-slate/70">
              Consultations by prior appointment only.
            </p>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-4 border-t border-ivory/10 pt-8 md:flex-row md:items-center md:justify-between">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate">&copy; {new Date().getFullYear()} Smart Legal Solutions</p>
          <div className="flex flex-wrap gap-6">
            <Link data-testid="footer-link-disclaimer" to="/disclaimer" className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate transition-colors hover:text-gold">Disclaimer</Link>
            <Link data-testid="footer-link-privacy" to="/privacy-policy" className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate transition-colors hover:text-gold">Privacy Policy</Link>
            <Link data-testid="footer-link-terms" to="/terms-of-use" className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate transition-colors hover:text-gold">Terms of Use</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
